export const className = (
  param: string | (string | boolean | undefined | null)[],
): string => {
  if (Array.isArray(param)) {
    return param.filter((item) => !!item).join(" ");
  }

  return param.toString();
};
